import { useContext } from 'react';

import withMetatags from 'core/hocs/withMetatags';
import { ArticleCategory, ArticlePreview as ArticlePreviewType } from 'types/models/Article';
import { ConfigContext, getShopKey, ShopKey } from '@providers/ConfigProvider';
import StaticLayout from '@layouts/StaticLayout';
import ArticleCategoryPreview from '@components/ArticleCategoryPreview';
import { FormattedMessage, MessageDescriptor } from 'utils/intl';
import map from 'utils/map';

import messages from './ArticlesCategories.messages';
import classes from './ArticlesCategories.module.scss';

type Props = {
  articleCategories: (Pick<ArticleCategory, 'id' | 'slug' | 'name'> & {
    articles: { article: ArticlePreviewType }[];
  })[];
  raw?: boolean;
};

const description: Record<ShopKey, MessageDescriptor> = {
  biznesowe: messages.biznesoweDescription,
  dellowo: messages.dellowoDescription,
  premiumStation: messages.premiumStationDescription,
  premiumSerwer: messages.premiumSerwerDescription,
  cocon: messages.coconDescription,
  firewall: messages.firewallDescription,
  rugged: messages.ruggedDescription,
  redarc: messages.redarcDescription,
};

export const ArticlesCategoriesView = ({ articleCategories, raw }: Props): JSX.Element => {
  const { shopId } = useContext(ConfigContext);
  const shopKey = getShopKey(shopId);

  return (
    <StaticLayout>
      <StaticLayout.Heading>
        <StaticLayout.Header>
          <FormattedMessage {...messages.articles} />
        </StaticLayout.Header>
        {description[shopKey] && (
          <StaticLayout.Description>
            <FormattedMessage {...description[shopKey]} />
          </StaticLayout.Description>
        )}
      </StaticLayout.Heading>
      <div className={classes.categories}>
        {articleCategories.map((articleCategory) => {
          const [mainArticle, ...articles] = articleCategory.articles;
          return (
            <ArticleCategoryPreview
              key={articleCategory.id}
              name={articleCategory.name}
              slug={articleCategory.slug}
              mainArticle={mainArticle.article}
              articles={map(articles, 'article')}
              raw={raw}
            />
          );
        })}
      </div>
    </StaticLayout>
  );
};

export default withMetatags(ArticlesCategoriesView, { withCanonicalUrl: true });
